<template>
  <div class="size-guide">
    <div v-if="sizeguide.description" class="size-guide__desc">{{ sizeguide.description }}</div>
    <div class="size-guide__table-wrapper">
      <SizeGuideTable :bodyMeasurements="sizeguide.bodyMeasurements" :fitType="fitType" />
    </div>
    <div class="size-guide__fit-type" v-for="type in fitTypeData" :key="type.title">
      <span class="size-guide__fit-type-title">{{ type.title }}</span>
      <span class="size-guide__fit-type-desc" v-html="type.content"></span>
    </div>
    <div class="size-guide__accor">
      <div
        class="size-guide__accor-wrapper"
        data-accor-size
        v-for="section in sizeguide.accordionSections"
        :key="section.title"
      >
        <div
          data-accor-ctrl-size
          class="size-guide__accor-ctrl"
          role="button"
          tabindex="0"
          :aria-controls="`size-guide-accor-section-${section.title}`"
          :aria-expanded="false"
          aria-roledescription="This is an accordion in size guide"
        >
          <div class="size-guide__accor-ctrl-title">{{ section.title }}</div>
          <svg class="size-guide__accor-ctrl-icon">
            <use href="#icon-next"></use>
          </svg>
        </div>
        <div
          data-accor-target-size
          :id="`size-guide-accor-section-${section.title}`"
          class="size-guide__accor-target"
          :aria-hidden="true"
        >
          <div class="size-guide__accor-image-wrapper" v-if="section.image">
            <!-- Need confirmation on this as images can be of different sizes -->
            <img  class="size-guide__accor-content-image" :src="section.image" />
            <!-- <ImageField
              class="size-guide__accor-content-image"
              :key="section.image"
              :obj="{ 'url': section.image, 'alt': 'Feature Image', 'width': 250 , 'height': 250 }"
              width-param="width"
            /> -->
          </div>
          <div class="size-guide__accor-content" v-html="section.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted, onBeforeMount } from 'vue';
  import SizeGuideTable from './size-guide-table.vue';
  import ImageField from '../global/image.vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({}),
    },
    sizeguide: {
      type: Object,
      default: () => ({}),
    },
    fitType: {
      type: String,
      default: null,
    },
    heading: {
        type: String,
        default: ''
    },
  });

  const emit = defineEmits(['component-updated']);

  const { product, sizeguide, fitType, heading } = toRefs(props);

  onBeforeMount(() => {
    emit('heading', heading.value);
  });

  onMounted(() => {
    accorFn();
    iconFn();
    emit('component-updated');
  });

  const fitTypeData = computed(() => {
    if (fitType.value) {
      return [
        {
          title: 'Fit',
          content: sizeguide.value.fitContentByType.find((item) => item.title.includes(fitType.value))?.content,
        },
      ];
    }
  });

  const accorFn = () => {
    const accors = document.querySelectorAll('[data-accor-size]');

    const init = (el) => {
      const ctrl = el.querySelector('[data-accor-ctrl-size]');
      const target = el.querySelector('[data-accor-target-size]');

      toggleAccorHeight(el, target, ctrl);

      const handleAccorInteraction = () => {
        accors.forEach((ele) => {
          const target = ele.querySelector('[data-accor-target-size]');
          target.style.setProperty('--accor-height', `0rem`);
          ele != el && ele.classList.remove('active');
        });

        el.classList.toggle('active');
        toggleAccorHeight(el, target, ctrl);
      };

      const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleAccorInteraction();
          event.preventDefault(); // Prevent scrolling with Space key
        }
      };

      ctrl.addEventListener('click', handleAccorInteraction);
      ctrl.addEventListener('keydown', handleKeyDown);
    };

    const toggleAccorHeight = (el, target, ctrl) => {
      if (el.classList.contains('active')) {
        target.style.setProperty('--accor-height', `${target.scrollHeight}px`);
        target.setAttribute('aria-hidden', false);

        ctrl.setAttribute('aria-expanded', true);
      } else {
        target.style.setProperty('--accor-height', `0rem`);
        target.setAttribute('aria-hidden', true);

        ctrl.setAttribute('aria-expanded', false);
      }
    };

    accors.forEach((el) => init(el));
  };

  const iconFn = () => {
    document.querySelectorAll('.callIcon').forEach((el) => {
      el.parentElement.classList.add('size-guide__iconWrapper');
      el.parentElement.setAttribute('aria-roledescription', 'Contact number');
      el.insertAdjacentHTML(
        'beforebegin',
        `<img class="size-guide__icon" alt="Call icon" src="https://cdn.shopify.com/s/files/1/0023/9901/0881/files/contact-us-4_30x.jpg?v=1537205239">`
      );
    });
    document.querySelectorAll('.chatIcon').forEach((el) => {
      el.parentElement.classList.add('size-guide__iconWrapper');
      el.parentElement.setAttribute('aria-roledescription', 'Chat link');
      el.insertAdjacentHTML(
        'beforebegin',
        `<img class="size-guide__icon" alt="Chat icon" src="https://cdn.shopify.com/s/files/1/0023/9901/0881/files/contact-us-3_30x.jpg?v=1537205256">`
      );
    });
    document.querySelectorAll('.emailIcon').forEach((el) => {
      el.parentElement.classList.add('size-guide__iconWrapper');
      el.parentElement.setAttribute('aria-roledescription', 'Send an email');
      el.insertAdjacentHTML(
        'beforebegin',
        `<img class="size-guide__icon" alt="Email icon" src="https://cdn.shopify.com/s/files/1/0023/9901/0881/files/CMS_Icons_-Recovered_30x.jpg?v=1537022422">`
      );
    });
  };
</script>
